import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { SavedGroceriesQueryVariables } from '@/gql/graphql';
import type { SavedGrocery } from '@/models/grocery';

export const fetchSavedGroceries = async ({ callerId, type }: SavedGroceriesQueryVariables): Promise<SavedGrocery[]> => {
  const response = await queryExecute({
    query: graphql(`
      query SavedGroceries($callerId: String!, $type: Float) {
        savedGroceries(callerId: $callerId, type: $type) {
          id
          callerId
          type
          name
          address
          streetAddress
          streetAddress2
          city
          state
          zip
          country
          latitude
          longitude
          order
          notes
          storeName
          updatedAt
          createdAt
          createdBy {
            lastName
            firstName
            id
          }
          updatedBy {
            lastName
            firstName
            id
          }
        }
      }
    `),
    variables: {
      callerId,
      type,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.savedGroceries;
};
